import React, { useEffect, useRef, useState } from 'react';
import { pxToRem } from '../util';

const ScrollingTable = ({
  columns = [],
  data = [],
  rowHeight = 40,
  visibleRows = 8,
  scrollInterval = 2000,
  className = '',
  style = {},
  needColumns = true,
}) => {
  const [index, setIndex] = useState(0);
  const [hover, setHover] = useState(false);

  const timerRef = useRef(null);
  const bodyRef = useRef(null);

  const needScroll = data.length > visibleRows;

  // 渲染两倍数据
  const renderData = needScroll ? [...data, ...data] : data;

  useEffect(() => {
    if (!needScroll) return;

    if (!hover) {
      timerRef.current = setInterval(() => {
        setIndex((prev) => prev + 1);
      }, scrollInterval);
    }

    return () => clearInterval(timerRef.current);
  }, [hover, scrollInterval, needScroll]);

  // 真正无缝循环核心
  useEffect(() => {
    if (!needScroll) return;

    if (index >= data.length) {
      const el = bodyRef.current;

      if (!el) return;

      setTimeout(() => {
        el.style.transition = 'none';

        setIndex((prev) => prev - data.length);

        requestAnimationFrame(() => {
          el.style.transition = 'transform 0.4s ease';
        });
      }, 400);
    }
  }, [index, data.length, needScroll]);

  const translateY = -(index * rowHeight);

  return (
    <div
      className={className}
      style={{
        overflow: 'hidden',
        position: 'relative',
        ...style,
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {needColumns && (
        <table
          style={{
            width: '100%',
            tableLayout: 'fixed',
            borderCollapse: 'collapse',
          }}
        >
          <thead>
            <tr>
              {columns.map((col, i) => (
                <th
                  key={i}
                  style={{
                    height: pxToRem(40),
                    padding: pxToRem(8),
                    color: '#fff',
                    textAlign: col.align || 'left',
                    width: col.width,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>
        </table>
      )}

      {/* 滚动区域 */}
      <div
        style={{
          height: visibleRows * rowHeight,
          overflow: 'hidden',
        }}
      >
        <table
          style={{
            width: '100%',
            tableLayout: 'fixed',
            borderCollapse: 'collapse',
          }}
        >
          <tbody
            ref={bodyRef}
            style={{
              transform: `translate3d(0, ${translateY}px, 0)`,
              transition: 'transform 0.4s ease',
            }}
          >
            {renderData.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                style={{
                  height: rowHeight,
                  color: 'white',
                  // background: rowIndex % 2 === 0 ? '#fff' : '#fafafa',
                }}
              >
                {columns.map((col, colIndex) => {
                  const rawValue = row[col.dataIndex];

                  const value = col.render
                    ? col.render(rawValue, row, rowIndex)
                    : rawValue;

                  return (
                    <td
                      key={colIndex}
                      style={{
                        padding: '0px ' + pxToRem(12),
                        textAlign: col.align || 'left',
                        width: col.width,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',

                        // 避免滚动时边框闪烁
                        boxShadow: 'inset 0 -1px 0 rgba(255, 255, 255, 0.05)',
                      }}
                      title={typeof value === 'string' ? value : undefined}
                    >
                      {value}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 状态 */}
      {/* {needScroll && (
        <div
          style={{
            position: 'absolute',
            bottom: 6,
            right: 10,
            fontSize: 12,
            color: '#666',
            background: 'rgba(255,255,255,0.9)',
            padding: '2px 6px',
            borderRadius: 4,
          }}
        >
          {hover ? '暂停' : '滚动'} {(index % data.length) + 1} / {data.length}
        </div>
      )} */}
    </div>
  );
};

export default ScrollingTable;
